import React from "react";
import useMobile from "../../../../../../hooks/useMobile";
import config from "../../../../../../constants/config";

import "./index.scss"


export const PureFileIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.6666 2.5V5.83333C11.6666 6.05435 11.7544 6.26631 11.9107 6.42259C12.067 6.57887 12.2789 6.66667 12.5 6.66667H15.8333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14.1666 17.5H5.83329C5.39127 17.5 4.96734 17.3244 4.65478 17.0118C4.34222 16.6993 4.16663 16.2754 4.16663 15.8333V4.16667C4.16663 3.72464 4.34222 3.30072 4.65478 2.98816C4.96734 2.67559 5.39127 2.5 5.83329 2.5H11.6666L15.8333 6.66667V15.8333C15.8333 16.2754 15.6577 16.6993 15.3451 17.0118C15.0326 17.3244 14.6087 17.5 14.1666 17.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.5 5.83398H8.33333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.5 10.834H12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.8334 14.166H12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;

const Mock = () => <div>
    <span className="d-flex align-items-center">
        <span className="skeleton skeleton3 mr-2 static" style={{ background: "var(--black1)", borderRadius: ".25rem", width: 20, height: 20 }} />
        <span className="skeleton skeleton4 static" style={{ background: "var(--black0)", width: 120, height: 12 }} />
    </span>
    <span className="skeleton skeleton2 static small" style={{ background: "var(--black0)", width: 50, height: 12 }} />
</div>

export default ({ data, currency }) => {

    let isMobile = useMobile();

    const compare = ( a, b ) => {
        if (+b.revenue < +a.revenue){
            return -1;
        }
        if (+b.revenue > +a.revenue){
            return 1;
        }
        return 0;
    }

    let payments = data.sort(compare);

    if(isMobile && !payments.length) {
        return null;
    }

    return <div className="payments-methods standard-block">
        <div className="standard-title">Payment Method</div>
        <div className="payments-methods-body">
            {payments.map(({ gateway, orders_count, revenue}, key) => <div key={key}>
                    <span className="d-flex align-items-center">
                        {config.PAYMENT_ICONS[gateway] ? <img className="payments-methods-icon" src={config.PAYMENT_ICONS[gateway]} alt=""/> : <div className="payments-methods-icon free"><PureFileIcon /></div>}
                        <span>{config.PAYMENT_FULL_NAME[gateway] ? config.PAYMENT_FULL_NAME[gateway] : 'No gateway'}</span>
                    </span>
                    <span>{currency}{revenue}</span>
                </div>
            )}
            {payments.length < 8 && !isMobile ?
                Array
                    .from({ length: 8 - payments.length }, (v, i) => i)
                    .map((key) => <Mock key={key} />)
                : null
            }
        </div>
    </div>
}